import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RadioField from '../../../Inventory/reusableComponents/AddOption/fields/RadioField';
import ButtonScogoPrimary from '../../../../common/Buttons/ButtonScogoPrimary';
import { motion } from 'framer-motion';
import { chatNotification } from '../../../../actions/chat';

const sendNotificationsForOptions = [
    { value: 'ALL', name: 'all', label: 'All Messages' },
    { value: 'MENTIONS_ONLY', name: '@only', label: '@Mentions Only' },
    { value: 'NONE', name: 'none', label: 'None' },
];

const formName = 'modify'

function ModifyNotificationSettings({ conversationId, mainDivClass }) {
    const chatDetails = useSelector((state) => state.chat.chatDetails);

    const dispatch = useDispatch();
    const isChangeNotificationSettingsLoading = useSelector((state) => state.loading.isChangeNotificationSettingsLoading);
    const [sendNotificationsFor, setSendNotificationsFor] = useState('');

    const currentMode = useMemo(() => {
        if (chatDetails[conversationId]) {
            setSendNotificationsFor(chatDetails[conversationId]?.notification_mode);
            return chatDetails[conversationId]?.notification_mode;
        }
        return '';
    }, [chatDetails, conversationId]);

    const handleSave = () => {
        dispatch(chatNotification({ id: conversationId, mode: sendNotificationsFor }))
    };

    return (
        <div className={`${mainDivClass} border-t border-gray-200`}>
            <div className="flex items-center justify-between mb-5">
                <h3 className="text-lg font-semibold text-scogoprimary flex items-center">
                    <span className="material-icons mr-2 text-scogoprimary text-font16">notifications</span>
                    Notification Settings
                </h3>
            </div>

            <div className="flex flex-col space-y-4">
                <RadioField
                    radioOptions={sendNotificationsForOptions}
                    value={sendNotificationsFor}
                    className="flex flex-wrap gap-3"
                    radioClassName="bg-gray-50 hover:bg-gray-100 transition-colors rounded-md px-3 py-2 text-font12"
                    activeRadioClassName="bg-scogolightblue text-scogoprimary font-medium"
                    onChangeHandler={({ value }) => setSendNotificationsFor(value)}
                />

                {sendNotificationsFor !== currentMode && (
                    <motion.div
                        initial={{ opacity: 0, y: 5 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="flex justify-end"
                    >
                        <ButtonScogoPrimary
                            textOrComponent="Save Changes"
                            buttonClass="text-sm font-medium"
                            buttonPadding="px-4 py-2"
                            onClick={handleSave}
                            loading={isChangeNotificationSettingsLoading}
                        />
                    </motion.div>
                )}

                <div className="text-gray-500 text-sm">
                    Choose how you want to be notified for messages in this conversation.
                </div>
            </div>
        </div>
    );
}

export default ModifyNotificationSettings;
